import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Copy,
  Modal,
  ModalOverlay,
  SecondaryButton,
  Title,
  Wrapper
} from "app/NativeComponents/common";
import { TextButton } from "app/NativeComponents/snippets";

import {
  appRedirect,
  setModal,
  switchMapMode,
  toggleActionSheet,
  toggleModal,
  startPlannedRoute,
  startTrackedRoute,
  checkIfUserHasModule,
  setFeatureModal,
  setPricingPage,
  togglePricingPage
} from "app/NativeActions";

class DrivingMode extends Component {
  constructor(props) {
    super(props);
    const plan_module_info = checkIfUserHasModule({
      plan_modules: props.plan_modules,
      user: props.user,
      slug: "driving"
    });
    this.state = {
      plan_module_info: plan_module_info
    };
  }

  render() {
    if (this.props.actionSheet == "switch_driving_mode") {
      return (
        <ModalOverlay
          isVisible={true}
          onPress={() => this.props.toggleActionSheet(null)}
        >
          <Modal actionSheet>
            <Card
              style={{
                minWidth: "95%",
                paddingBottom: this.props.device == "mobile" ? 10 : 0
              }}
            >
              <CardBody>
                <Title style={{ textAlign: "center" }}>
                  Select a Driving Mode
                </Title>
                <Copy style={{ textAlign: "center" }}>
                  How do you want to drive for leads?
                </Copy>
              </CardBody>
              <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                <SecondaryButton
                  onPress={() => {
                    if (!this.props.track_route) {
                      this.props.startTrackedRoute({
                        token: this.props.token
                      });
                    }
                    this.props.toggleActionSheet(null);
                  }}
                >
                  Free Drive Mode
                </SecondaryButton>
              </Card>

              {this.props.device == "mobile" ? (
                <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                  <SecondaryButton
                    onPress={() => {
                      if (this.state.plan_module_info.tier > 1) {
                        this.props.appRedirect({
                          redirect: "build_list",
                          payload: { route_plan: true }
                        });
                      } else {
                        if (this.props.platform == "ios") {
                          this.props.setModal({
                            title: "Upgrade Required",
                            description:
                              "You need upgrade to the Street Engine Professional Plan to use planned routes. Open DealMachine on the web to update your account.",
                            icon: "lock",
                            submit: "Dismiss",
                            onPress: () => {},
                            cancel: "",
                            onCancel: () => {}
                          });
                          this.props.toggleModal({
                            show: true,
                            type: "normal"
                          });
                        } else {
                          this.props.setModal({
                            title: "Upgrade Required",
                            description:
                              "You need upgrade to the Street Engine Professional Plan to use planned routes.",
                            icon: "lock",
                            submit: "Upgrade to Professional",
                            onPress: () => {
                              this.props.setPricingPage({
                                title: "Upgrade Engine",
                                engine_slug: "driving",
                                tier: 2,
                                frequency: "annually"
                              });
                              this.props.togglePricingPage(true);
                            },
                            cancel: "No. Not right now.",
                            onCancel: () => {}
                          });
                          this.props.toggleModal({
                            show: true,
                            type: "normal"
                          });
                        }
                      }

                      this.props.toggleActionSheet(null);
                    }}
                    betaText={this.props.platform == "ios" ? "New" : "Beta"}
                  >
                    Planned Route Mode
                  </SecondaryButton>
                </Card>
              ) : null}
              <TextButton
                onPress={() => this.props.toggleActionSheet(null)}
                text={"Cancel"}
              />
            </Card>
          </Modal>
        </ModalOverlay>
      );
    }
    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, billing, property_map }) => {
  const { token, user } = auth;
  const { plan_modules } = billing;
  const { actionSheet, device, platform, isMobile } = native;
  const { switch_driving_mode } = property_map;
  return {
    token,
    user,
    plan_modules,
    actionSheet,
    platform,
    isMobile,
    device,
    switch_driving_mode
  };
};

export default connect(mapStateToProps, {
  toggleActionSheet,
  switchMapMode,
  startTrackedRoute,
  startPlannedRoute,
  appRedirect,
  setModal,
  toggleModal,
  setFeatureModal,
  setPricingPage,
  togglePricingPage
})(DrivingMode);
